module.exports = __webpack_public_path__ + "static/media/01.e83716f0.mp3";